/**
 * Spremljeni raspored nadzorne ploče.
 *
 * Verzija se podiže kad se promijeni značenje spremljenog rasporeda (minimalne
 * veličine, broj stupaca, breakpointi). Stari zapis se tada jednom očisti — bez
 * toga bi korisnik ostao na rasporedu koji je nastao po drugim pravilima.
 */
export const DASHBOARD_STATE_KEY = "dashboard-state";
export const OVERVIEW_LAYOUTS_KEY = "overview-grid-layouts";

const VERSION_KEY = "dashboard-state-version";
const VERSION = "4";

export const resetOutdatedDashboardState = (): void => {
  if (localStorage.getItem(VERSION_KEY) === VERSION) return;

  localStorage.removeItem(DASHBOARD_STATE_KEY);
  localStorage.removeItem(OVERVIEW_LAYOUTS_KEY);
  localStorage.setItem(VERSION_KEY, VERSION);
};
